import { memo } from 'react';

import styles from './DesktopPlaceholder.less';

export const DesktopPlaceholder = memo(() => (
  <div className={styles.desktopPlaceholder} data-placeholder="desktop" />
));
